// state/api/statisticsFacade.js


// RAW
import {fetchVehicleSiteDailyAggregations as rawFetchSiteDailyAgg,} from "../api/statisticsDataAPI";

// PROCESSED
import {fetchVehicleSiteDailyAggregations as prFetchSiteDailyAgg,} from "../api/statisticsProcessedDataAPI";
import {selectDataMode} from "../slice/dataModeSlice";

/* ------------------ slice pickers ------------------ */
const pickSlice = (state) =>
    selectDataMode(state) === "processed" ? state.statisticsProcessedDataAPI : state.statisticsDataAPI;

export const selectSitesAgg = (state) =>
    pickSlice(state)?.sites || { loading: false, data: {}, ids: [], error: null };


/* ------------------ thunks (mode-aware) ------------------ */
const isProcessed = (getState) => selectDataMode(getState()) === "processed";


export const fetchVehicleSiteDailyAggregationsActive = (args) => (dispatch, getState) =>
    isProcessed(getState) ? dispatch(prFetchSiteDailyAgg(args)) : dispatch(rawFetchSiteDailyAgg(args));
